import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import styled from "styled-components";
import { CalendarToday } from "@mui/icons-material";
import DatePicker, { ReactDatePickerProps } from "react-datepicker";

import { useDate } from "../../utility/useDate"

interface PortalDatePickerProps extends ReactDatePickerProps {
    label?: string,
    testId?: string,
    readOnly?: boolean,
    defaultMinDate?: boolean,
}

export default function PortalDatePicker(props: PortalDatePickerProps) {

    const { convertTZ, toFormattedFullDateString } = useDate();

    const Wrapper = styled.div`
        & .react-datepicker-popper {
            z-index: 2;
        }
    `;

    const datePickerProps = {...props};

    if (datePickerProps.defaultMinDate) {
        datePickerProps.minDate = convertTZ(new Date());
    }

    datePickerProps.selected = datePickerProps.value ? new Date(datePickerProps.value) : undefined;

    if (datePickerProps.defaultMinDate) {
        if (datePickerProps.selected && datePickerProps.minDate && datePickerProps.selected < datePickerProps.minDate) {
            datePickerProps.selected = datePickerProps.minDate
        }
    }

    const customInput = <TextField
        size="small"
        variant="outlined"
        label={props.label}
        style={{display: "inline-block"}}
        InputProps={{
            endAdornment: <InputAdornment position="end"><CalendarToday /></InputAdornment>,
            value: toFormattedFullDateString(datePickerProps.selected)
        }} />;

    return (
        <Wrapper>
            {props && <DatePicker 
                customInput={customInput}
                {...datePickerProps} />}
        </Wrapper>
    );
}